import axios from 'axios'
import React, { useEffect, useState } from 'react'

const useCustomData = (url) => {
   const[data,setData]=useState([]);
  useEffect(()=>{
    axios.get(url)
    .then((res)=>{
      setData(res.data)
    })
    .catch((err)=>{
      alert("Error Fetching the  Data")
    })
  })
  return  data;
}

export default useCustomData